import { REVENUE_MANAGEMENT_ROOT_ENDPOINT } from "./RootEndpoint";

export const REVENUE_MANAGEMENT_RAK = `${REVENUE_MANAGEMENT_ROOT_ENDPOINT}/rak-manager`;
export const REVENUE_MANAGEMENT_RAK_UPDATE_RATE = `${REVENUE_MANAGEMENT_ROOT_ENDPOINT}/rak-manager/%1$s`;

export const REVENUE_MANAGEMENT_RAK_RATE = `${REVENUE_MANAGEMENT_ROOT_ENDPOINT}/rak-manager/%1$s`;
